module.exports = __webpack_public_path__ + "lamp.jpg?b8089cb99d687c5186c4a0e37a78eb5f";